import VerticalSliderMobile from './VerticalSliderMobile'
export default VerticalSliderMobile
